<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card>
    <div slot="no-body" class="full-page-bg-color">
      <div :class="renderContainerClass()">
        <div class="vx-col w-full">
          <div class="p-8 login-tabs-container">
            <div class="mb-base" v-for="error in apiErrors" :key="error.message">
              <vs-alert color="danger" icon="new_releases">
                <span>{{ error }}</span>
              </vs-alert>
            </div>

            <form id="registerForm" class="mb-base" @submit.prevent>
              <!-----REGISTRATION METHOD PAGE----->
              <div v-show="stepIndex == 1">
                <ValidationObserver ref="formRegistrationMethod">
                  <h4 class="mb-3">{{ $t("register.letsStart") }}</h4>
                  <p class="mb-base">
                    {{ $t("register.chooseRegistrationMethod") }}
                  </p>
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                      <!--<vs-tabs
                            alignment="fixed"
                            @input="(index) => (emailSignUpMethod = index == 0 ? true : false)"
                          >
                            <vs-tab :label="$t('attribute.email')" class="px-0 pb-0"> </vs-tab>
                            <vs-tab :label="$t('attribute.phoneNumber')" class="px-0 pb-0"> </vs-tab>
                          </vs-tabs>-->

                      <div v-if="emailSignUpMethod">
                        <ValidationProvider name="email" :rules="`required|email`" v-slot="{ errors }">
                          <vs-input
                            v-model="form.email"
                            name="email"
                            v-bind:placeholder="$t('form.enter', { attribute: $t('attribute.email') })"
                            icon-no-border
                            icon="icon icon-user"
                            icon-pack="feather"
                            class="w-full"
                          />
                          <small class="text-danger text-sm">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </div>
                      <div v-else>
                        <ValidationProvider
                          name="phoneNumber"
                          ref="proPhoneNumber"
                          rules="required|max:20"
                          v-slot="{ valid, errors }"
                        >
                          <vue-tel-input
                            name="phoneNumber"
                            class="vs-inputx normal hasValue"
                            v-bind:placeholder="$t('form.enter', { attribute: $t('attribute.phoneNumber') })"
                            :defaultCountry="$store.getters.getUserCountry.code"
                            :maxLen="20"
                            :mode="`international`"
                            :validCharactersOnly="true"
                            @input="(number, object) => checkPhoneNumber(number, object)"
                          >
                          </vue-tel-input>
                          <input type="hidden" v-model="form.phone_number" />
                          <div class="text-danger text-sm" v-show="!phoneValid & (form.phone_number != null)">
                            {{ $t("form.inputValidPhone") }}
                          </div>
                          <small class="text-danger text-sm" v-show="!valid">
                            {{ errors[0] }}
                          </small>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <vs-button style="width: 100%" @click.prevent="onSubmitFirstForm()" :disabled="btnLoading">
                    {{ $t("action.next") }}
                  </vs-button>
                </ValidationObserver>
              </div>
              <!-----END REGISTRATION METHOD PAGE----->

              <!-----OTP PAGE----->
              <div v-show="stepIndex == 2" :key="`${stepIndex}_otp`">
                <ValidationObserver ref="formOTP">
                  <h4 class="mb-3">{{ $t("otp.verifyOTP") }}</h4>
                  <ValidationProvider name="OTP" rules="required">
                    <OTPFormComponent ref="refFormOTP" v-bind="sendTo" v-model="otp.number" class="mb-3" />
                  </ValidationProvider>

                  <div class="flex justify-between flex-wrap">
                    <vs-button
                      @click.prevent="changePreviousStep(2)"
                      type="border"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-chevron-left"
                      :disabled="btnLoading"
                    >
                      {{ $t("action.previous").toUpperCase() }}
                    </vs-button>
                    <vs-button
                      @click.prevent="onSubmitSecondForm()"
                      type="filled"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-chevron-right"
                      icon-after
                      :disabled="btnLoading"
                    >
                      {{ $t("action.next").toUpperCase() }}
                    </vs-button>
                  </div>
                </ValidationObserver>
              </div>
              <!-----OTP PAGE----->

              <!-----USER INFORMATION PAGE----->
              <div v-show="stepIndex == 3" :key="`${stepIndex}_user_info`">
                <ValidationObserver ref="formUserInformation">
                  <h4 class="mb-3">{{ $t("register.fillUserInformationTitle") }}</h4>
                  <p class="mb-base">
                    {{ $t("register.fillUserInformationInstr") }}
                  </p>
                  <div class="mb-3">
                    <div class="w-full" v-if="emailSignUpMethod">
                      <label class="vs-input--label">{{ $t("attribute.email") }}</label>
                      <vs-alert color="success">
                        <vs-icon icon="email" class="mr-5"></vs-icon><span>{{ this.form.email }}</span>
                      </vs-alert>
                    </div>
                    <div class="w-full" v-else>
                      <label class="vs-input--label">{{ $t("attribute.phoneNumber") }}</label>
                      <vs-alert color="success">
                        <vs-icon icon="call" class="mr-5"></vs-icon><span>{{ this.form.phone_number }}</span>
                      </vs-alert>
                    </div>
                  </div>
                  <div class="mb-3">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                      <vs-input
                        v-model="form.name"
                        name="name"
                        v-bind:label="$t('attribute.name')"
                        v-bind:placeholder="$t('form.enter', { attribute: $t('attribute.name') })"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        class="w-full"
                      />
                      <small class="text-danger text-sm" v-show="!valid">
                        {{ errors[0] }}
                      </small>
                    </ValidationProvider>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col sm:w-full md:w-full lg:w-1/2 mb-3">
                      <ValidationProvider vid="password" name="password" rules="required" v-slot="{ valid, errors }">
                        <vs-input
                          type="password"
                          v-model="form.password"
                          name="password"
                          ref="password"
                          v-bind:label="$t('attribute.password')"
                          v-bind:placeholder="$t('form.enter', { attribute: $t('attribute.password') })"
                          v-validate="'min:8|max:25|required'"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          class="w-full"
                        />
                        <small class="text-danger text-sm" v-show="!valid">
                          {{ errors[0] }}
                        </small>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col sm:w-full md:w-full lg:w-1/2 mb-3">
                      <ValidationProvider
                        name="passwordConfirmation"
                        rules="required|confirmed:password"
                        v-slot="{ valid, errors }"
                      >
                        <vs-input
                          type="password"
                          v-model="form.confirm_password"
                          name="passwordConfirmation"
                          v-bind:label="$t('attribute.passwordConfirmation')"
                          v-bind:placeholder="
                            $t('form.enter', {
                              attribute: $t('attribute.passwordConfirmation'),
                            })
                          "
                          v-bind:data-vv-as="$t('attribute.password')"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          class="w-full"
                        />
                        <small class="text-danger text-sm" v-show="!valid">
                          {{ errors[0] }}
                        </small>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-base">
                    <div class="vx-col w-full">
                      <ValidationProvider name="preferredState" rules="required" v-slot="{ valid, errors }">
                        <small>{{ $t("attribute.preferredState") }}</small>
                        <v-select
                          v-model="form.country"
                          name="preferredState"
                          v-bind:placeholder="$t('form.enter', { attribute: $t('attribute.preferredState') })"
                          v-validate="'required'"
                          class="w-full"
                          icon-pack="feather"
                          icon="icon icon-user"
                          label="name"
                          :options="$store.state.country.country_list"
                        />
                        <small>
                          <i>
                            {{ $t("register.countryChoice") }}
                          </i>
                        </small>
                        <small class="text-danger text-sm" v-show="!valid">
                          {{ errors[0] }}
                        </small>
                      </ValidationProvider>
                    </div>
                  </div>

                  <vs-button style="width: 100%" @click.prevent="onSubmitThirdForm()" :disabled="btnLoading">
                    {{ $t("register.signUp") }}
                  </vs-button>
                </ValidationObserver>
              </div>
              <!-----END USER INFORMATION PAGE----->
            </form>

            <vs-divider>{{ $t("login.or") }}</vs-divider>

            <div class="mb-2">
              <small class="text-center">
                {{ $t("forgetPassword.haveAccount") }}?
                <router-link to="/login">{{ $t("forgetPassword.signIn") }} </router-link>
              </small>
            </div>
            <div class="mb-2">
              <small class="text-center">
                {{ $t("login.forgotPassword") }}?
                <router-link to="/account/forget-password">{{ $t("login.changeHere") }}</router-link>
              </small>
            </div>
            <div>
              <small class="text-center">
                {{ $t("login.needHelp") }}?
                <router-link to="/helpcenter?origin=public_customer">{{ $t("login.clickHere") }}</router-link>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<style scoped>
#registerForm .vs-input--label {
  text-transform: capitalize;
}
</style>

<script>
//import Crypto from '@/helper/crypto'
import ErrorHandler from "@/helper/error_handler";
import vSelect from "vue-select";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
import OTPFormComponent from "@/components/OTPFormComponent.vue";
import { VueTelInput } from "vue-tel-input";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";

export default {
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone_number: null,
        country: null,
        password: null,
        confirm_password: null,
      },
      emailSignUpMethod: true,
      otp: {
        number: null,
        transactionID: null,
      },
      stepIndex: 1,
      phoneValid: 0,
      apiErrors: [],
      btnLoading: false,
    };
  },
  computed: {
    sendTo() {
      return this.emailSignUpMethod ? { email: this.form.email } : { phoneNumber: this.form.phone_number };
    },
    authAccountDetail() {
      return this.emailSignUpMethod ? this.form.email : this.form.phone_number;
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
    VueTelInput,
    VxTimeline,
    OTPFormComponent,
  },
  mounted() {
    this.initializeCountryCurrency(this);
    this.renderContainerClass();
    this.defineDefaultState();
  },
  methods: {
    defineDefaultState() {
      this.form.country = this.$store.getters.getUserCountry;

      if (!this.form.country) {
        this.form.country = null;
      }
    },
    renderContainerClass() {
      let name = "vx-row no-gutter justify-center items-center d-theme-dark-bg";
      /*if (!this.isMobile()) {
        name = `${name} h-screen`;
      }*/

      return name;
    },
    openAlert() {
      this.$vs.dialog({
        color: "success",
        acceptText: this.$t("alert.accept"),
        title: this.$t("register.successRegisterTitle"),
        text: this.$t("register.successRegisterBody"),
        accept: this.navigateToLogin(),
      });
    },
    navigateToLogin() {
      this.$router.push({ name: "login" });
    },
    changePreviousStep(index) {
      this.clearAlert();
      this.stepIndex = index - 1;
    },
    changeNextStep(index) {
      this.clearAlert();
      this.stepIndex = index + 1;
    },
    async onSubmitFirstForm() {
      let valid = await this.$refs.formRegistrationMethod.validate();

      if (valid && !this.emailSignUpMethod) {
        valid = this.phoneValid;
      }

      if (valid) {
        this.clearAlert();
        this.btnLoading = true;

        const userExist = await this.checkUserExist();

        if (!userExist) {
          await this.$refs.refFormOTP
            .sendOTP()
            .then((res) => {
              this.changeNextStep(1);
            })
            .catch((err) => {
              this.apiErrors = ErrorHandler.processErrorMessage(err);
            });
        } else {
          this.apiErrors = [this.$t("register.accountExist") + ". " + this.$t("register.directToLogin")];
        }
        this.btnLoading = false;
      }
    },
    async onSubmitSecondForm() {
      this.clearAlert();

      let valid = await this.$refs.formOTP.validate();

      if (valid) {
        this.btnLoading = true;

        try {
          const result = await this.$refs.refFormOTP.verifyOTP();

          if (result.transactionID) {
            this.otp.transactionID = result.transactionID;
            this.changeNextStep(2);
          }
          this.btnLoading = false;
        } catch (err) {
          this.btnLoading = false;
        }
      }
    },
    async onSubmitThirdForm() {
      this.clearAlert();

      let valid = await this.$refs.formUserInformation.validate();

      if (valid && !this.emailSignUpMethod) {
        valid = this.phoneValid;
      }

      if (valid) {
        this.registerAccount();
      }
    },
    checkPhoneNumber(formattedNumber, phoneObject) {
      this.form.phone_number = phoneObject.number;
      this.phoneValid = phoneObject.valid ? true : false;
    },
    checkUserExist() {
      let param = {};
      if (this.emailSignUpMethod) {
        param.email = this.form.email;
      } else {
        param.phone_number = this.form.phone_number;
      }

      return this.$store.dispatch("checkUserExist", param);
    },
    registerAccount() {
      try {
        this.$validator.validateAll().then((result) => {
          this.$vs.loading({
            type: "radius",
            text: `${this.$t("register.processRegister")}...`,
          });

          this.btnLoading = true;

          let param = {
            name: this.form.name,
            company_name: this.form.company_name,
            password: this.form.password,
            country_id: this.form.country.id,
            otp_transaction_id: this.otp.transactionID,
          };

          if (this.emailSignUpMethod) {
            param.email = this.form.email;
          } else {
            param.phone_number = this.form.phone_number;
          }

          this.$http
            .post(this.$endpoints.user_register, param)
            .then(() => {
              this.openAlert();
            })
            .catch((err) => {
              this.apiErrors = ErrorHandler.processErrorMessage(err);
            })
            .finally(() => {
              this.$vs.loading.close();
            });

          this.btnLoading = false;
        });
      } catch (err) {
        console.log(err);
      }
    },
    clearAlert() {
      this.apiErrors = [];
    },
  },
};
</script>

<style lang="scss">
label {
  display: "hidden";
}
</style>
